import { render } from "./ReserveWindow.vue?vue&type=template&id=24dca18c"
import script from "./ReserveWindow.vue?vue&type=script&lang=js"
export * from "./ReserveWindow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__